import { Link } from 'react-router-dom'
import { Download as DownloadIcon, Monitor, Globe, Check } from 'lucide-react'

const INSTALLER_URL = '/downloads/PlutonicStudio-Setup.msi'

const Download = () => {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <img
          src="/PLUTONIC_LOGO_WHITE_NOBG.png"
          alt="Plutonic Studio"
          className="h-14 w-auto object-contain mx-auto mb-4"
        />
        <h1 className="text-2xl font-bold text-white mb-2">Scarica l'app per Windows</h1>
        <p className="text-gray-500 text-sm mb-8">
          La stessa piattaforma, in un'app desktop con la sua finestra e icona. Si aggiorna da sola.
        </p>

        {/* Card download */}
        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 mb-6">
          <div className="w-14 h-14 bg-violet-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Monitor size={28} className="text-violet-400" />
          </div>
          <a
            href={INSTALLER_URL}
            className="w-full flex items-center justify-center gap-2 bg-violet-600 hover:bg-violet-500 text-white font-semibold py-3 rounded-xl transition-colors"
          >
            <DownloadIcon size={18} />
            Scarica per Windows
          </a>
          <p className="text-gray-600 text-xs mt-3">Windows 10 / 11 · 64 bit · installer .msi</p>
        </div>

        {/* Vantaggi */}
        <div className="text-left space-y-2 mb-8">
          {[
            'Finestra dedicata, senza barra del browser',
            'Icona sul desktop e nella barra applicazioni',
            'Sempre aggiornata all\'ultima versione',
          ].map((t) => (
            <div key={t} className="flex items-center gap-2.5 text-sm text-gray-400">
              <Check size={15} className="text-violet-400 flex-shrink-0" />
              {t}
            </div>
          ))}
        </div>

        {/* Alternativa web */}
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
        >
          <Globe size={15} />
          Oppure usa la versione web nel browser
        </Link>

        <p className="text-gray-700 text-xs mt-8">
          Alla prima apertura Windows potrebbe mostrare un avviso di sicurezza (SmartScreen):
          clicca "Ulteriori informazioni" → "Esegui comunque". È normale per le app non ancora firmate.
        </p>
      </div>
    </div>
  )
}

export default Download
